import { KEY_VALUE_SEPARATOR } from '../../constants/DevicePluginGenerator';
import { splitStringOnFirst } from './splitStringOnFirst';

/**
 * Parses a single raw header string "Key:Value" into a key/value pair,
 * splitting on the FIRST colon only so that colons inside the value are preserved
 * (e.g. SOAPACTION values like "urn:Belkin:service:basicevent:1#SetBinaryState").
 * When there is no colon, the whole string is treated as the key and the value is empty.
 * @param {string} headerString - raw header, e.g. "SOAPACTION:urn:Belkin:service:1"
 * @returns {{ key: string, value: string }} - e.g. { key: "SOAPACTION", value: "urn:Belkin:service:1" }
 */
export const parseHeaderString = (headerString = '') => {
    const { before, after } = splitStringOnFirst(headerString, KEY_VALUE_SEPARATOR);

    return { key: before, value: after };
};
